import React, { useState, useEffect } from "react";
import { ArrowLeft, PlusCircle, Eye, Edit, Edit2, Trash2 } from "react-feather";
import { Link } from "react-router-dom";
import Table from "core/pagination/datatable";
import TableTop from "Components/UI/TableTop";
import { useTableSearch } from "core/Operations/useTableSearch";
import { useForm, FormProvider } from "react-hook-form";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { all_routes } from "Router/all_routes";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import Error404 from "MainPages/ErrorPages/error404";
import { yupResolver } from "@hookform/resolvers/yup";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { message, Switch } from "antd";
import ToastNotification from "Components/UI/ToastNotification";
import {
  useDeleteLevyTypeMutation,
  useGetLevyTypesQuery,
  useInsertLevyTypeMutation,
  useUpdateLevyTypeMutation,
} from "AppQuries/master/Levy/levy-type";
import { levyTypeValidationSchema } from "core/Operations/ValidationSchema/MasterValidationSchema";
import { getCurrentFormattedDate } from "core/Operations/currentDateTime";
import LevyTypeModal from "Components/Modal/master/levyType";
import { toast } from "core/Operations/toast";
import { BackIcon } from "Components/UI/Icon/Icons";
const LevyType = () => {
  const userData = useSelector(loggedInUser);
  const [showActiveOnly, setShowActiveOnly] = useState(true);
  const [isMount, setIsMount] = useState(false);
  const {
    data,
    isLoading,
    isError,
    error,
    refetch: getItems,
  } = useGetLevyTypesQuery(
    {
      companyCode: userData?.companyCode,
      isTrue: showActiveOnly,
    },
    {
      enabled: userData?.companyCode,
    }
  );
  const methods = useForm({
    resolver: yupResolver(levyTypeValidationSchema),
  });
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [message, setMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);

  const { mutate: addItem, isPending: isAdding } = useInsertLevyTypeMutation();
  const { mutate: updateItem, isPending: isUpdating } =
    useUpdateLevyTypeMutation();

  const { mutate: deleteItem, isPending: isDeleting } =
    useDeleteLevyTypeMutation();
  const [selectedItem, setSelectedItem] = useState(null);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const ItemData = Array.isArray(data)
    ? data?.map((d, _id) => ({
        id: _id + 1,
        ...d,
      }))
    : [];

  const handleAddClick = () => {
    setSelectedItem(null);
    methods.reset({
      companyCode: userData.companyCode,
      code: 0,
      description: "",
      isActive: true,
      createUser: userData.userName,
      createDate: getCurrentFormattedDate(),
      modifyUser: userData.userName,
      modifyDate: getCurrentFormattedDate(),
    });
    setShow(true);
  };

  const handleEditClick = (item) => {
    setSelectedItem(item);
    methods.reset({
      companyCode: item.companyCode,
      code: item.code,
      description: item.description,
      isActive: item.isActive,
      createUser: item.createUser,
      createDate: item.createDate,
      modifyUser: userData.userName,
      modifyDate: getCurrentFormattedDate(),
    });
    setShow(true);
  };

  const deleteItemHandler = (id) => {
    const payload = {
      companyCode: userData?.companyCode,
      code: id,
    };
    deleteItem(payload, {
      onSuccess: (data) => {
        if (data) {
          message.success("Item Deleted Successfully.");
          setShow(false);
          getItems();
        } else {
          message.success(data?.[0]?.errorMessage || "Something went wrong.");
        }
      },
      onError: (error) => {
        message.danger(error.message || "Something went wrong.");
      },
    });
  };

  const onSubmit = async (payload) => {
    if (selectedItem) {
      updateItem(payload, {
        onSuccess: (data) => {
          if (data) {
            toast.success("Updated Successfully.");
            setShow(false);
            getItems();
          } else {
            toast.warning(data?.[0]?.errorMessage || "Something went wrong.");
          }
        },
        onError: (error) => {
          toast.error(error.message || "Something went wrong.");
        },
      });
    } else {
      addItem(payload, {
        onSuccess: (data) => {
          if (data) {
            toast.success("Item Added Successfully.");
            setShow(false);
            getItems();
          } else {
            toast.warning(data?.[0]?.errorMessage || "Something went wrong.");
          }
        },
        onError: (error) => {
          toast.error(error.message || "Something went wrong.");
        },
      });
    }
  };

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "id",
      sorter: (a, b) => a.id.length - b.id.length,
      render: (text, record) => <>{text}</>,
    },

    {
      title: "Description",
      dataIndex: "description",
      sorter: (a, b) => a.description.length - b.description.length,
    },

    {
      title: "Created User",
      dataIndex: "createUser",
      sorter: (a, b) => a.createUser.length - b.createUser.length,
    },

    {
      title: "Status",
      dataIndex: "isActive",
      render: (text, record) => (
        <>
          {text === true && (
            <div className="badges badge-linesuccess">Active</div>
          )}
          {text === false && (
            <div className="badges badge-linedanger">In Active</div>
          )}
        </>
      ),
    },

    {
      title: "Action",
      dataIndex: "action",
      className: "action-table-data",
      render: (text, record) => (
        <div className="edit-delete-action">
          <div className="input-block add-lists"></div>

          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="add-new-tooltip">Edit</Tooltip>}
          >
            <Link className="me-2 p-2" onClick={() => handleEditClick(record)}>
              <Edit className="feather-edit" />
            </Link>
          </OverlayTrigger>

          {/* <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="add-new-tooltip">Delete</Tooltip>}
          >
            <Link className="me-2 p-2" to="#">
              <Popconfirm
                title="Are you sure to Delete?"
                onConfirm={() => deleteItemHandler(record.code)}
              >
                <Trash2 className="feather-delete" />
              </Popconfirm>
            </Link>
          </OverlayTrigger> */}
        </div>
      ),
    },
  ];

  const searchColumns = columns.map((column) => column.dataIndex);
  const { setSearchValue, filteredData } = useTableSearch(
    ItemData,
    searchColumns
  );

  useEffect(() => {
    if (isMount) getItems();

    setIsMount(true);
  }, [showActiveOnly]);

  if (isLoading || isAdding || isUpdating) {
    return <LoadingSpinner />;
  }

  if (isError) {
    return <Error404 error={error} />;
  }

  return (
    <>
      <div className="toast-container position-fixed top-0 end-0 p-3">
        <ToastNotification
          showSuccessToast={showSuccessToast}
          showErrorToast={showErrorToast}
          message={message}
        />
      </div>
      <div className="page-wrapper">
        <div className="content">
          {/* <Breadcrumbs maintitle="Call History" subtitle="Manage your products" /> */}
          <div className="page-header">
            <div className="page-title">
              <h4>Levy Type</h4>
              <h6>Manage Levy Type </h6>
            </div>
            <div className="page-btn" style={{ display: "flex" }}>
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id="add-new-tooltip">Add New Levy Type</Tooltip>
                }
              >
                <Link to="#" className="btn btn-added" onClick={handleAddClick}>
                  
                  <PlusCircle className="me-2" />
                  Add
                </Link>
              </OverlayTrigger>
              &nbsp;
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
              >
                <Link to={`${all_routes.master}`} className="btn btn-secondary">
                  <i className="fas fa-reply me-2"></i>
                  Back
                </Link>
              </OverlayTrigger>
            </div>
          </div>

          <div className="card table-list-card border-0">
            <div className="card-body">
              <TableTop
                onSearch={setSearchValue}
                toggleFilterVisibility={toggleFilterVisibility}
                isFilterVisible={isFilterVisible}
                showToggle={false}
              />
              <div
                className={`card${isFilterVisible ? " visible" : ""}`}
                id="filter_inputs"
                // style={{ display: isFilterVisible ? "block" : "none" }}
              >
                
                <div className="card-body pb-0">
                  <div className="form-row row">
                    <div className="row">
                      <div className="col-lg-3 col-sm-6 col-12 mb-3">
                        <div className="form-group">
                          <Switch
                                checked={showActiveOnly}
                                checkedChildren="Show Active"
                                unCheckedChildren="Show All"
                                onChange={(checked) => setShowActiveOnly(checked)}
                              />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="table-responsive">
                <Table
                  className="table  datanew"
                  columns={columns}
                  dataSource={filteredData}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <FormProvider {...methods}>
        <LevyTypeModal
          mode={selectedItem ? "E" : "I"}
          onSubmit={onSubmit}
          show={show}
          handleClose={handleClose}
        />
      </FormProvider>
    </>
  );
};

export default LevyType;
